module.exports = __webpack_public_path__ + "img/webchat.695df9bf.svg";